import { render, staticRenderFns } from "./selectorStaff.vue?vue&type=template&id=2ea16bd0"
import script from "./selectorStaff.vue?vue&type=script&lang=js"
export * from "./selectorStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports